import { DialogController } from "../dialog-controller";

export interface AlertDialogData {
    title: string;
    body: string;
}

export class AlertDialogController extends DialogController<AlertDialogData> {
    constructor() {
        super({
            logLabel: 'AlertDialogController',
            dialogId: 'alert-dialog',
            closeButtonId: 'alert-dialog-close-button',
        });
    }

    protected onDialogOpened(): void {
        this._setState();
    }

    protected onDialogClosed(): void {
        this._setState();
    }

    protected _setState(): void {
        const title = this.getElementByIdOrWarn('alert-dialog-title');
        const body = this.getElementByIdOrWarn('alert-dialog-body');
        if (title) {
            title.textContent = this.isOpen ? this.data.title : '';
        }
        if (body) {
            body.innerHTML = this.isOpen ? this.data.body : '';
        }
    }
}
